import React from 'react';

const Privacy = () => {
  return (
    <div className="privacy-page" style={{ maxWidth: '900px', margin: '0 auto', padding: '2rem 1rem' }}>
      <h1 style={{ color: 'var(--gold)', fontSize: '2.5rem', marginBottom: '1.5rem' }}>
        Privacy & Principles
      </h1>

      <div style={{ marginBottom: '2rem' }}>
        <h2 style={{ color: 'var(--gold)', fontSize: '1.8rem', marginBottom: '1rem' }}>
          Your Voice, Your Rules
        </h2>
        <p style={{ color: 'var(--text-light)', fontSize: '1.1rem', lineHeight: '1.6', marginBottom: '1rem' }}>
          At Zpost, we believe that free speech is a fundamental right. We don't algorithmically amplify or suppress your content.
          Your voice reaches your audience without interference.
        </p>
        <p style={{ color: 'var(--text-light)', fontSize: '1.1rem', lineHeight: '1.6', marginBottom: '1rem' }}>
          Our platform is built on the principle that you own your identity. Your <strong>.zpost.eth</strong> ENS domain is your property –
          minted by you, controlled by you, and portable anywhere in the Web3 ecosystem.
        </p>
      </div>

      <div style={{ marginBottom: '2rem' }}>
        <h2 style={{ color: 'var(--gold)', fontSize: '1.8rem', marginBottom: '1rem' }}>
          Your Data is Your Own
        </h2>
        <p style={{ color: 'var(--text-light)', fontSize: '1.1rem', lineHeight: '1.6', marginBottom: '1rem' }}>
          Unlike traditional platforms, we don't collect, sell, or monetize your personal information.
          Your profile data – avatar, bio, social links – lives as ENS records on the Ethereum blockchain.
          It's public by design (like any blockchain) but you are the sole controller.
        </p>
        <p style={{ color: 'var(--text-light)', fontSize: '1.1rem', lineHeight: '1.6', marginBottom: '1rem' }}>
          Messages on Zhat are end‑to‑end encrypted; we cannot read them. We only store metadata necessary for delivery.
        </p>
      </div>

      <div style={{ marginBottom: '2rem' }}>
        <h2 style={{ color: 'var(--gold)', fontSize: '1.8rem', marginBottom: '1rem' }}>
          Self‑Sovereign Identity
        </h2>
        <p style={{ color: 'var(--text-light)', fontSize: '1.1rem', lineHeight: '1.6', marginBottom: '1rem' }}>
          Your <strong>.zpost.eth</strong> domain is your universal Web3 identity. You can use it anywhere ENS is supported –
          other dapps, wallets, or even sell it. We merely provide the platform; you own the keys.
        </p>
        <p style={{ color: 'var(--text-light)', fontSize: '1.1rem', lineHeight: '1.6', marginBottom: '1rem' }}>
          This means you can take your identity, your followers, and your content to any other application that respects
          the ENS standard. No lock‑in, no walled garden.
        </p>
      </div>

      <div style={{ marginBottom: '2rem' }}>
        <h2 style={{ color: 'var(--gold)', fontSize: '1.8rem', marginBottom: '1rem' }}>
          Content Moderation
        </h2>
        <p style={{ color: 'var(--text-light)', fontSize: '1.1rem', lineHeight: '1.6', marginBottom: '1rem' }}>
          We believe in free expression, but we also expect civilized discourse. Content that is illegal (as defined by
          applicable law) or that directly harasses individuals may be removed. We do not proactively moderate opinions.
        </p>
      </div>

      <div style={{ 
        padding: '1.5rem', 
        background: 'rgba(255,215,0,0.05)', 
        borderRadius: '8px', 
        border: '1px solid var(--gold)',
        marginTop: '2rem'
      }}>
        <p style={{ color: 'var(--text-secondary)', fontStyle: 'italic', margin: 0 }}>
          "Free speech doesn't mean free from consequences – it means freedom from centralized control.
          Zpost gives you that freedom. Your voice, your rules."
        </p>
      </div>
    </div>
  );
};

export default Privacy;
